export default {
  // Page title
  title: 'Activity Detail',
  // KPI cards
  participantCount: 'Participants',
  winnerCount: 'Winners',
  loserCount: 'Non-winners',
  yesterday: 'Yesterday:',
  // Tab labels
  tabBasic: 'Basic Info',
  tabScope: 'Activity Scope',
  tabPrize: 'Activity Prizes',
  tabStrategy: 'Activity Strategy',
  // Basic info
  activityStatus: 'Activity Status',
  activityName: 'Activity Name',
  activityId: 'Activity ID',
  activityTemplate: 'Activity Template',
  activityTime: 'Activity Time Period',
  activityRemark: 'Activity Remark',
  activityRule: 'Activity Rule',
  createTime: 'Create Time',
  // Activity scope
  colRangeType: 'Range Type',
  colCodeRange: 'Code Range',
  colCodeCount: 'Code Count',
  emptyScope: 'No activity scope data',
  // Activity prizes
  colPrizeName: 'Prize Name',
  colPrizePercent: 'Win Rate',
  colPrizeContent: 'Prize Content',
  colPrizePloy: 'Linked Strategy',
  emptyPrize: 'No activity prize data',
  // Activity strategy
  colStrategyName: 'Strategy Name',
  colStrategyRules: 'Strategy Rules',
  colStrategyStatus: 'Strategy Status',
  emptyStrategy: 'No activity strategy data',
};
